import ClientHeader from '../../../components/ClientHeader/ClientHeader'
import FillrateSummary from '../../../components/FillRateSummary/FillrateSummary'
import TraceSummary from '../components/TraceSummary/TraceSummary'
import SectionCard from '../../../layout/SectionCard'

import { OC_CLIENT_HEADER_CONFIG, OC_SUMMARY_CARDS } from '../constants/ocConstants'
import { formatMoney, formatPercentSmart } from '../../../helpers/utils'
import { resolveLastActivityDate } from '../helpers/resolveLastActivityDate'

import { Chip } from '@mui/material'

export default function ClientDashboard({ summary, tabsOrders, last_activity_at }) {
  if (!summary) return null

  const originalLines = summary.cards?.oc_original?.lines ?? 0
  const lastActivity = resolveLastActivityDate(last_activity_at)

  const preparedCards = OC_SUMMARY_CARDS.map(card => {
    const { fill_rate, lines = 0, total } = summary.cards?.[card.key] ?? {}

    const isEmpty = fill_rate == null || lines === 0
    const linesLabel =
      card.key === 'oc_original'
        ? String(lines)
        : lines && originalLines
          ? `${lines}/${originalLines}`
          : '0'

    return {
      ...card,
      value: formatPercentSmart(fill_rate),
      disabled: isEmpty,
      status: isEmpty ? 'PENDIENTE' : null,
      lines: linesLabel,
      amount: total ? formatMoney(Number(total)) : '0.00'
    }
  })

  return (
    <div className="container-fluid mt-3">
      <ClientHeader
        data={summary.sale_data}
        config={OC_CLIENT_HEADER_CONFIG.normal}
      />

      <SectionCard
        title="FILL RATE DE LA ORDEN"
        headerRight={
          lastActivity && (
            <Chip
              size="small"
              label={`Última actualización: ${lastActivity.date.format('DD/MM/YYYY')}`}
              className="section-card-last-activity-chip"
            />
          )
        }
      >
        <FillrateSummary cards={preparedCards} />
      </SectionCard>

      <SectionCard title="TRAZABILIDAD">
        <TraceSummary data={tabsOrders} />
      </SectionCard>
    </div>
  )
}
